export default [
  {
    product: "Necklace",
    description: "Custom Designed Necklaces",
    img: "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1137&q=80",
  },
  {
    product: "Bangles",
    description: "Custom Designed Bangles",
    img: "https://images.unsplash.com/photo-1611598935678-c88dca238fce?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
  },
  {
    product: "Ear-Rings",
    description: "Custom Designed Ear-rings",
    img: "https://images.pexels.com/photos/8752665/pexels-photo-8752665.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    product: "Rings",
    description: "Custom Designed Rings",
    img: "https://images.pexels.com/photos/1430956/pexels-photo-1430956.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    product: "Bracelets",
    description: "Custom Designed Bracelets",
    img: "https://images.unsplash.com/photo-1611107683227-e9060eccd846?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
  },
  {
    product: "Waist Chain",
    description: "Custom Designed Waist Chain",
    img: "https://i.pinimg.com/originals/43/76/5b/43765b5720e349d81374601d638fdf6c.jpg",
  },
];
